import { SuperDate } from '@razlet/utils';
import Raid from '../raid';
import { resolveVolumePrecision, roundVolume } from '~/utils/volume';

export default class ShipmentMovement {
  data = null;

  raid = null;

  movedAt = null;

  constructor (data) {
    this.data = data;

    if (data.raid) this.raid = new Raid(data.raid);
    this.movedAt = new SuperDate(data.movementAt);
  }

  get id () {
    return this.data.id;
  }

  get status () {
    return this.data.status;
  }

  get cargoPartsCode () {
    return this.data.cargoPartsCode;
  }

  get raid () {
    return this.raid;
  }

  get cargo () {
    if (!this.data?.cargo) return {};
    const precision = resolveVolumePrecision({
      company: this.data.shipmentCompany ||
        this.raid?.data?.companyCode || this.raid?.data?.iataCompany,
    });
    const volume = roundVolume(this.data.cargo.volume, precision);
    return {
      ...this.data.cargo,
      volume,
      fullName: `${this.data.cargo.pieces}/${this.data.cargo.weight}/${volume}`,
    };
  }

  get movedAt () {
    return this.movedAt;
  }

  get location () {
    return this.data.location;
  }

  get fullName () {
    // eslint-disable-next-line vue/max-len
    return `${this.location} ${this.status} ${this.movedAt.shortDateWithTime}`;
  }
};
